import { z } from "zod";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export const loginSchema = z.object({
  email: z.email("errors.invalidEmail").min(1, "errors.requiredField"),
  pass: z.string().min(1, "errors.requiredField"),
});

export const recoverPasswordSchema = z.object({
  email: z.email("errors.invalidEmail").min(1, "errors.requiredField"),
});

export const resetPasswordSchema = z
  .object({
    pass: z
      .string()
      .min(1, "errors.requiredField")
      .regex(passwordRegex, "errors.passwordTooWeak"),
    confirmPass: z
      .string()
      .min(1, "errors.requiredField")
      .regex(passwordRegex, "errors.passwordTooWeak"),
  })
  .refine((data) => data.pass === data.confirmPass, {
    message: "errors.passwordsDoNotMatch",
    path: ["confirmPass"],
  });

export const changePasswordSchema = resetPasswordSchema.extend({
  currentPassword: z.string().min(1, "errors.requiredField"),
});

export const registerStartSchema = z.object({
  email: z.email("errors.invalidEmail").min(1, "errors.requiredField"),
});

export const registerCompleteSchema = z
  .object({
    email: z.email("errors.invalidEmail").min(1, "errors.requiredField"),
    name: z.string().min(1, "errors.requiredField"),
    surname: z.string().min(1, "errors.requiredField"),
    companyName: z.string().min(1, "errors.requiredField"),
    customerCode: z.string().trim(),
    companyCIF: z
      .string()
      .trim()
      .refine(
        (v) => v === "" || /^[A-Za-z]\d{7}[A-Za-z0-9]$|^\d{8}[A-Za-z]$/.test(v),
        "contacte.formulari.pressupost.nifcif.error2",
      ),
    position: z.string().trim().min(1, "errors.requiredField"),
    phone: z
      .string()
      .regex(
        /^\+?[0-9][0-9\s]{8,14}$/,
        "contacte.formulari.pressupost.telefon.error2",
      )
      .min(1, "errors.requiredField"),
    authorization: z.boolean().refine((v) => v, {
      message: "errors.requiredField",
    }),
  })
  // Hay que indicar el código de cliente o el CIF (basta con uno de los dos).
  .refine(
    (v) => !!(v.customerCode ?? "").trim() || !!(v.companyCIF ?? "").trim(),
    {
      message: "register.form.customerCodeOrCIFRequired",
      path: ["customerCodeOrCIF"],
      when: () => true,
    },
  );

export const contactEmailSchema = z.object({
  to: z.email("errors.invalidEmail").min(1, "errors.requiredField"),
  subject: z.string().min(1, "errors.requiredField"),
  message: z.string().min(1, "errors.requiredField"),
});
